import React from 'react'
import {Typography, Divider, Space, Tag, Table, Checkbox, Alert} from "antd";
import dayjs, { Dayjs } from 'dayjs'
import _ from "lodash";
import { FaRegCheckCircle } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import language from "../../../resources/languages/en_US"
import { Enum } from "../../../resources/constants"

// Interfaces
import { Tender as TenderType } from "../../../interfaces/pages/opportunities"

// Commons
import { exportPdf } from "../../../commons/export-pdf";

const { App: { title }, Pages: { Opportunities: { Tender } }, Share, Enum: EnumLanguage } = language
const { OverallStatus, Snapshot } = Enum;

export const DecisionIntelligence = async (tender: TenderType) => {
    const solicitationName = tender?.title || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Solicitation_Name })?.Value;
    const issueDate = tender?.publishDate || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Issue_Date })?.Value;
    const endUserName = tender?.agency || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.End_User_Name })?.Value;
    const endUserAddress = tender?.deliveryLocation || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.End_User_Address })?.Value;
    const submissionDeadline = tender?.dueDate || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Submission_Deadline })?.Value;
    const questionnaireDeadline = tender?.dueDate || tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Questionnaire_Deadline })?.Value;
    const submissionMethod = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Submission_Method })?.Value;
    const typeOfPurchase = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Type_Of_Purchase })?.Value || {};
    const goodsDescription = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Goods_Description })?.Value;
    const training = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Training })?.Value || {};
    const installation = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Installation })?.Value || {};
    const preventiveMaintenance = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Preventive_Maintenance })?.Value || {};
    const sparePartKit = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Spare_Part_Kit })?.Value || {};
    const anyStandardApproval = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Any_Standard_Approval })?.Value || {};
    const warranty = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Warranty })?.Value || {};
    const evaluationMethod = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Evaluation_Method })?.Value;
    const requestedDeliveryDate = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Requested_Delivery_Date })?.Value;
    const deliveryTerm = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Delivery_Term })?.Value;
    const deliveryLocation = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Delivery_Location })?.Value;
    const paymentTerm = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Payment_Term })?.Value;
    const notes = tender?.snapshotTable && _.findLast(tender.snapshotTable, { Field: Snapshot.Notes })?.Value;

    await exportPdf([
        <>
            <div className={'content'}>
                <Space direction={'vertical'} size={2} style={{width: '100%'}}>
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.summary}</Divider>
                    {
                        tender?.snapshotTable && (
                            <>
                                <table className={'snapshot-table'}>
                                    <tbody>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Solicitation_Name]}</td>
                                        <td className={'description'} colSpan={4}>{solicitationName}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Issue_Date]}</td>
                                        <td className={'description'}
                                            colSpan={4}>{ (issueDate && dayjs(issueDate).isValid()) ? dayjs(issueDate).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY') : Share.notSpecified}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.End_User_Name]}</td>
                                        <td className={'description'} colSpan={4}>{endUserName}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.End_User_Address]}</td>
                                        <td className={'description'} colSpan={4}>{endUserAddress}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'} colSpan={5}><span
                                            className={'label'}>{Tender.contractAuthority}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Submission_Deadline]}</td>
                                        <td className={'description'}
                                            colSpan={4}>{(submissionDeadline && dayjs(submissionDeadline).isValid()) ? dayjs(submissionDeadline).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY') : Share.notSpecified}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Questionnaire_Deadline]}</td>
                                        <td className={'description'}
                                            colSpan={4}>{(questionnaireDeadline && dayjs(questionnaireDeadline).isValid()) ? dayjs(questionnaireDeadline).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY') : Share.notSpecified}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Submission_Method]}</td>
                                        <td className={'description'} colSpan={4}>{submissionMethod}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Type_Of_Purchase]}</td>
                                        <td className={'description'}>{Object.entries(typeOfPurchase).length > 0 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(typeOfPurchase)[0][1])}/><span>{Object.entries(typeOfPurchase)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(typeOfPurchase).length > 1 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(typeOfPurchase)[1][1])}/><span>{Object.entries(typeOfPurchase)[1][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(typeOfPurchase).length > 2 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(typeOfPurchase)[2][1])}/><span>{Object.entries(typeOfPurchase)[2][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(typeOfPurchase).length > 3 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(typeOfPurchase)[3][1])}/><span>{Object.entries(typeOfPurchase)[3][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Goods_Description]}</td>
                                        <td className={'description'} colSpan={4}>{goodsDescription}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'} colSpan={5}><span
                                            className={'label'}>{Tender.estimateValue}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={'title'} rowSpan={2}>{Tender.service}</td>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Training]}</td>
                                        <td className={'description'}>{Object.entries(training).length > 0 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(training)[0][1])}/><span>{Object.entries(training)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(training).length > 1 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(training)[1][1])}/><span>{Object.entries(training)[1][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(training).length > 2 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(training)[2][1])}/><span>{Object.entries(training)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Installation]}</td>
                                        <td className={'description'}>{Object.entries(installation).length > 0 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(installation)[0][1])}/><span>{Object.entries(installation)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(installation).length > 1 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(installation)[1][1])}/><span>{Object.entries(installation)[1][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(installation).length > 2 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(installation)[2][1])}/><span>{Object.entries(installation)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Preventive_Maintenance]}</td>
                                        <td className={'description'}>{Object.entries(preventiveMaintenance).length > 0 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(preventiveMaintenance)[0][1])}/><span>{Object.entries(preventiveMaintenance)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(preventiveMaintenance).length > 1 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(preventiveMaintenance)[1][1])}/><span>{Object.entries(preventiveMaintenance)[1][0]}</span></Space>}</td>
                                        <td className={'description'} colSpan={2}>{Object.entries(preventiveMaintenance).length > 2 && <Space><input type={'checkbox'} checked={Boolean(Object.entries(preventiveMaintenance)[2][1])}/><span>{Object.entries(preventiveMaintenance)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Spare_Part_Kit]}</td>
                                        <td className={'description'}>{Object.entries(sparePartKit).length > 0 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(sparePartKit)[0][1])}/><span>{Object.entries(sparePartKit)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(sparePartKit).length > 1 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(sparePartKit)[1][1])}/><span>{Object.entries(sparePartKit)[1][0]}</span></Space>}</td>
                                        <td className={'description'}
                                            colSpan={2}>{Object.entries(sparePartKit).length > 2 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(sparePartKit)[2][1])}/><span>{Object.entries(sparePartKit)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Any_Standard_Approval]}</td>
                                        <td className={'description'}>{Object.entries(anyStandardApproval).length > 0 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(anyStandardApproval)[0][1])}/><span>{Object.entries(anyStandardApproval)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(anyStandardApproval).length > 1 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(anyStandardApproval)[1][1])}/><span>{Object.entries(anyStandardApproval)[1][0]}</span></Space>}</td>
                                        <td className={'description'}
                                            colSpan={2}>{Object.entries(anyStandardApproval).length > 2 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(anyStandardApproval)[2][1])}/><span>{Object.entries(anyStandardApproval)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Warranty]}</td>
                                        <td className={'description'}>{Object.entries(warranty).length > 0 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(warranty)[0][1])}/><span>{Object.entries(warranty)[0][0]}</span></Space>}</td>
                                        <td className={'description'}>{Object.entries(warranty).length > 1 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(warranty)[1][1])}/><span>{Object.entries(warranty)[1][0]}</span></Space>}</td>
                                        <td className={'description'}
                                            colSpan={2}>{Object.entries(warranty).length > 2 &&
                                            <Space><input type={'checkbox'}
                                                          checked={Boolean(Object.entries(warranty)[2][1])}/><span>{Object.entries(warranty)[2][0]}</span></Space>}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Evaluation_Method]}</td>
                                        <td className={'description'} colSpan={4}>{evaluationMethod}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Requested_Delivery_Date]}</td>
                                        <td className={'description'}
                                            colSpan={4}>{(requestedDeliveryDate && dayjs(requestedDeliveryDate).isValid()) ? dayjs(requestedDeliveryDate).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY') : Share.notSpecified}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Delivery_Term]}</td>
                                        <td className={'description'} colSpan={4}>{deliveryTerm}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Delivery_Location]}</td>
                                        <td className={'description'} colSpan={4}>{deliveryLocation}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Payment_Term]}</td>
                                        <td className={'description'} colSpan={4}>{paymentTerm}</td>
                                    </tr>
                                    <tr>
                                        <td className={'title'}>{EnumLanguage.Snapshot[Snapshot.Notes]}</td>
                                        <td className={'description'} colSpan={4}>{notes}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                        )
                    }
                </Space>
            </div>
            <div className={'page-number'}>1/5</div>
        </>,
        <>
            <div className={'content'}>
                <Space direction={'vertical'} size={2} style={{width: '100%'}}>
                    <Typography.Title level={1}>{tender?.title}</Typography.Title>
                    <Typography.Title className={'solicitation-number'}
                                      level={2}>{Tender.solicitationNumber}: {tender?.solicitationNumber}</Typography.Title>
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.overview}</Divider>
                    <Typography.Title level={3}>{Tender.projectScopeWorkService}</Typography.Title>
                    <Space key={'tag'}>
                        <Typography.Paragraph>
                            <Tag
                                color="#E8ECEF">{Tender.publishDate}: {tender?.publishDate && dayjs(tender?.publishDate).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY')}</Tag>
                            <Tag
                                color="#E8ECEF">{Tender.dueDate} {tender?.dueDate && dayjs(tender?.dueDate).tz(process.env.REACT_APP_TZ).format('MMMM D, YYYY') + ' RM EST Time ' + dayjs(tender?.dueDate).tz(process.env.REACT_APP_TZ).format('hh:mm')}</Tag>
                            <Tag
                                color="#E8ECEF">{Tender.psc}: {_.isArray(tender?.pscCode) ? tender?.pscCode?.join(", ")?.toLowerCase() : tender?.pscCode?.toLowerCase()}</Tag>
                            <Tag color="#E8ECEF">{Tender.naics}: {tender?.naicsCode?.toLowerCase()}</Tag>
                            <Tag
                                color="#E8ECEF">{Tender.noticeType}: {_.isArray(tender?.noticeType) ? tender?.noticeType?.join(", ")?.toLowerCase() : tender?.noticeType?.toLowerCase()}</Tag>
                        </Typography.Paragraph>
                    </Space>
                    <Typography.Title level={3}>{Tender.description}</Typography.Title>
                    <div
                        className={'description'}
                        dangerouslySetInnerHTML={{
                            __html: tender?.description || '',
                        }}/>
                    {
                        tender?.detailedView?.overview && (
                            <>
                                <p>{tender?.detailedView?.overview?.project_scope}</p>
                                <Typography.Title
                                    level={3}>{Tender.billOfMaterials}</Typography.Title>
                                <Table
                                    className={'ant-table-details'}
                                    columns={[
                                        {
                                            title: Tender.item,
                                            dataIndex: 'item',
                                            key: 'item',
                                        },
                                        {
                                            title: Tender.quantity,
                                            dataIndex: 'quantity',
                                            key: 'quantity',
                                        },
                                        {
                                            title: Tender.preferredVendor,
                                            dataIndex: 'preferred_vendor',
                                            key: 'preferred_vendor',
                                        },
                                        {
                                            title: Tender.modelNumber,
                                            dataIndex: 'model_number',
                                            key: 'model_number',
                                        },
                                        {
                                            title: Tender.technicalSpecification,
                                            dataIndex: 'technical_specification',
                                            key: 'technical_specification',
                                        }
                                    ]}
                                    dataSource={tender?.detailedView?.overview?.bill_of_materials}
                                    pagination={false}
                                    scroll={{x: true}}
                                />
                            </>
                        )
                    }
                </Space>
            </div>
            <div className={'page-number'}>2/5</div>
        </>,
        <>
            <div className={'content'}>
                <Space direction={'vertical'} size={5} style={{width: '100%'}}>
                    {
                        tender?.detailedView?.overview && (
                            <>
                                <Typography.Title
                                    level={3}>{Tender.vendorSelectionCriteria}</Typography.Title>
                                <p>
                                    <b>{Tender.alternateVendor}:</b> {tender?.detailedView?.overview?.vendor_selection_criteria?.preferred_vendor}
                                </p>
                                <Typography.Title
                                    level={3}>{Tender.additionalTechnicalInformation}</Typography.Title>
                                <p>{tender?.detailedView?.overview?.additional_technical_information}</p>
                            </>
                        )
                    }
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.delivery}</Divider>
                    {
                        tender?.detailedView?.delivery_inspection_test && (
                            <Space direction={'vertical'} size={2}>
                                <Typography.Title level={3}>{Tender.deliveryAddress}</Typography.Title>
                                <p>{tender?.detailedView?.delivery_inspection_test?.delivery_address}</p>
                                <Typography.Title level={3}>{Tender.placePerformance}</Typography.Title>
                                <p>{tender?.detailedView?.delivery_inspection_test?.place_of_performance}</p>
                            </Space>
                        )
                    }
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.buyer}</Divider>
                    {
                        tender?.detailedView?.buyer && (
                            <Space direction={'vertical'} size={2}>
                                <Typography.Title level={3}>{Tender.nameAgency}</Typography.Title>
                                <p>{tender?.detailedView?.buyer?.agency_name}</p>
                                <Typography.Title level={3}>{Tender.subTierName}</Typography.Title>
                                <p>{tender?.detailedView?.buyer?.sub_tier_name}</p>
                                <Typography.Title level={3}>{Tender.officeName}</Typography.Title>
                                <p>{tender?.detailedView?.buyer?.office_name}</p>
                                <Typography.Title level={3}>{Tender.contactInformation}</Typography.Title>
                                <p>{tender?.detailedView?.buyer?.contact_information?.map(({ email, name, phone }) => (
                                    <ul>
                                        <li><b>{Tender.name}: </b><span>{name}</span></li>
                                        <li><b>{Tender.email}: </b><span>{email}</span></li>
                                        <li><b>{Tender.phone}: </b><span>{phone}</span></li>
                                    </ul>
                                ))}</p>
                                <Typography.Title level={3}>{Tender.buyerWebsite}</Typography.Title>
                                <p>{tender?.detailedView?.buyer?.buyer_website}</p>
                            </Space>
                        )
                    }
                </Space>
            </div>
            <div className={'page-number'}>3/5</div>
        </>
        ,
        <>
            <div className={'content'}>
                <Space direction={'vertical'} size={5} style={{width: '100%'}}>
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.inspectionTest}</Divider>
                    {
                        tender?.detailedView?.delivery_inspection_test && (
                            <Space direction={'vertical'} size={2}>
                                <Typography.Title level={3}>{Tender.specificTestsRequested}</Typography.Title>
                                <p>{tender?.detailedView?.delivery_inspection_test?.specific_tests_requested}</p>
                                <Typography.Title level={3}>{Tender.inspectionsRequested}</Typography.Title>
                                <p>{tender?.detailedView?.delivery_inspection_test?.inspections_requested}</p>
                                <Typography.Title level={3}>{Tender.additionalRequiredSteps}</Typography.Title>
                                <p>{tender?.detailedView?.delivery_inspection_test?.additional_required_steps}</p>
                            </Space>
                        )
                    }
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.compliance}</Divider>
                    {
                        tender?.detailedView?.compliance && (
                            <Space direction={'vertical'} size={10} style={{width:'100%'}}>
                                <Typography.Title level={3}>{Tender.setAsideInformation}</Typography.Title>
                                { tender?.detailedView?.compliance?.set_aside_information && <Tag color="#E8ECEF">{tender?.detailedView?.compliance?.set_aside_information}</Tag> }
                                <Typography.Title level={3}>{Tender.requiredCertificates}</Typography.Title>
                                <ul>
                                    {tender?.detailedView?.compliance?.required_certificates?.map((item) => <li>{item}</li>)}
                                </ul>
                                <Typography.Title level={3}>{Tender.warrantyDetails}</Typography.Title>
                                <p>{tender?.detailedView?.compliance?.warranty_details}</p>
                                <Typography.Title level={3}>{Tender.guaranteeDetails}</Typography.Title>
                                <p>{tender?.detailedView?.compliance?.guarantee_information}</p>
                                <Typography.Title level={3}>{Tender.legalClauses}</Typography.Title>
                                <Table
                                    className={'ant-table-details'}
                                    columns={[
                                        {
                                            title: Tender.clauseNumber,
                                            dataIndex: 'clause_number',
                                            key: 'clause_number',
                                        },
                                        {
                                            title: Tender.clauseTitle,
                                            dataIndex: 'clause_title',
                                            key: 'clause_title',
                                        },
                                        {
                                            title: Tender.description,
                                            dataIndex: 'description',
                                            key: 'description',
                                        }
                                    ]}
                                    dataSource={tender?.detailedView?.compliance?.legal_clauses}
                                    pagination={false}
                                    scroll={{ x: true }}
                                />
                            </Space>
                        )
                    }
                </Space>
            </div>
            <div className={'page-number'}>4/5</div>
        </>
        ,
        <>
            <div className={'content'}>
                <Space direction={'vertical'} size={5} style={{width: '100%'}}>
                    <Divider orientation="left" dashed orientationMargin="0">{Tender.decisionIntelligence}</Divider>
                    {
                        !(_.isEmpty(tender?.eligibilityTable) && _.isEmpty(tender?.recommendations)) && (
                            <>
                                <Typography.Title level={3}>{Tender.eligibilityReview}</Typography.Title>
                                <Table
                                    className={'ant-table-details'}
                                    columns={[
                                        {
                                            title: Tender.requirement,
                                            dataIndex: 'requirement',
                                            key: 'requirement',
                                        },
                                        {
                                            title: Tender.userStatus,
                                            dataIndex: 'userStatus',
                                            key: 'userStatus',
                                            render: (text, record) => text === OverallStatus.Met ? <Tag icon={<FaRegCheckCircle size={10} color={'#0bda1c'} />} className={'ant-tag-user-status'}>{text}</Tag> : text === OverallStatus.Further_Investigation_Required ? <Tag icon={<FiAlertTriangle size={10} color={'#d8741d'} />} className={'ant-tag-user-status'}>{text}</Tag> : <Tag className={'ant-tag-user-status'}>{text}</Tag>
                                        },
                                        {
                                            title: Tender.reference,
                                            dataIndex: 'reference',
                                            key: 'reference',
                                        },

                                    ]}
                                    dataSource={tender?.eligibilityTable}
                                    pagination={false}
                                    scroll={{x: true}}
                                />
                                <Alert
                                    message={Tender.overallStatus}
                                    description={<b>{tender?.overallStatus}</b>}
                                    type="info"
                                    showIcon
                                />
                                <Typography.Title level={3}>{Tender.recommendations}</Typography.Title>
                                <ul>
                                    {
                                        tender?.recommendations?.map((recommendation: string) => <li>{recommendation}</li>)
                                    }
                                </ul>
                            </>
                        )
                    }
                </Space>
            </div>
            <div className={'page-number'}>5/5</div>
        </>
        ,
    ], 'decision-intelligence', tender.solicitationNumber)
}